import { Menu, MenuButton, MenuList, MenuItem, Button, Tooltip } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { requeueIcon, shuffleIcon, editQueueIcon } from "./queue-icons";

interface QueueActionsDropdownProps {
  onRequeue: () => void;
  onShuffle: () => void;
  onEditQueue: () => void;
}

export function ActionsDropdown({ onRequeue, onShuffle, onEditQueue }: QueueActionsDropdownProps) {
  return (
    <Menu autoSelect={false}>
      <MenuButton as={Button} rightIcon={<ChevronDownIcon />} variant="secondary">
        Actions
      </MenuButton>
      <MenuList >
        <Tooltip label="After adding/deleting slots in your queue schedule, use this feature to re-queue every post according to your new queue schedule.">
          <MenuItem icon={requeueIcon} onClick={onRequeue}>
            Re-Queue
          </MenuItem>
        </Tooltip>
        <Tooltip label="Shuffle all your content and push them at the top of your queue.">
          <MenuItem icon={shuffleIcon} onClick={onShuffle}>
            Shuffle
          </MenuItem>
        </Tooltip>
        <MenuItem icon={editQueueIcon} onClick={onEditQueue}>
          Edit Queue
        </MenuItem>
      </MenuList>
    </Menu>
  );
}

